// Authentication guard for protected routes - redirects to signin if not authenticated
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@stores/auth.store';
import { Spin } from 'antd';
import { Spinner } from '@/pages/style';
import Cube3DLoader from '@/components/ui/Cube3DLoader';

const RequireAuth = ({ children }) => {
    const user = useAuthStore((state) => state.user);
    const isRefreshing = useAuthStore((state) => state.isRefreshing);
    const location = useLocation();

    if (isRefreshing) {
        return <Cube3DLoader overlay size={48} />;
    }

    if (!user) {
        return <Navigate to="/sign-in" state={{ from: location }} replace />;
    }

    return children;
};

export default RequireAuth;
